// Special extend method that respects property descriptors and allows us to
// override getters/setters using mixins. Something you wouldn't normally be
// able to do with `Object.assign` or event `_.extend`.
const extendWithDescriptor = function(obj) {
	Array.prototype.slice.call(arguments, 1).forEach(function(source) {
		var descriptor, prop;
		if (source) {
			for (prop in source) {
				descriptor = Object.getOwnPropertyDescriptor(source, prop);
				Object.defineProperty(obj, prop, descriptor);
			}
		}
	});
	return obj;
};

export default extendWithDescriptor;
